/**
 * Valida el id que se interpola en la ruta de una acción de detalle.
 *
 * ─── Por qué existe ──────────────────────────────────────────────────────────
 *
 * La misma equivocación apareció **cuatro veces** en el proyecto: una acción
 * que construye `entidad/${id}/` recibiendo un objeto —los filtros, o un
 * `request.options` importado— en vez del id.
 *
 * El origen está localizado: las pantallas de LISTADO llaman
 * `warrantyList(filters, options)`, con dos argumentos, y las de DETALLE
 * copiaron esa forma a acciones que sólo aceptan el id.
 *
 * Lo caro no es el fallo, es que **no se oye**: JavaScript interpola el objeto
 * como `[object Object]`, el servidor devuelve 404, el reducer de fallo hace su
 * trabajo y la pantalla se queda con los datos anteriores. Todo «funciona».
 *
 * Esta guarda no cambia la petición —devuelve el valor tal cual— pero deja un
 * error en consola que nombra la acción culpable.
 */
export const idParaRuta = (valor, nombreDeAccion) => {
  const esUsable =
    (typeof valor === 'string' && valor !== '') || typeof valor === 'number'

  if (!esUsable) {
    console.error(
      `[${nombreDeAccion}] esperaba un id y recibió ${
        valor === null ? 'null' : typeof valor
      }. ` +
        'La ruta saldrá mal formada y la petición fallará en silencio. ' +
        'Comprueba si se copió la firma de una acción de listado, que toma ' +
        '(filtros, opciones).'
    )
  }

  return valor
}
